import React from 'react';
import logo from '../../Assets/logo.png';
import { useNavigate } from 'react-router-dom';

const ExpiredPopUp = () => {
    const navigate = useNavigate();
    return (
        <div className='fixed inset-0 flex items-center justify-center p-8 bg-popup-bg-color backdrop-blur-[2px] z-[--after-registration-popup]'>
            <div className='bg-white w-full md:w-4/5 lg:w-2/5 space-y-3 rounded-2xl flex flex-col items-center p-6 pt-12'>
                <img className='h-8' src={logo} alt="zepcruit-icon" />
                <h3 className='font-semibold text-2xl text-center'>
                    Interview Link Expired
                </h3>
                <p className='text-center text-[#7D7D7D] leading-relaxed'>
                    Your interview link is expired. Reach out to the HR for more information.
                </p>
                <button>
                    <span
                        onClick={() => navigate('/dashboard')}
                        className="px-5 py-2 bg-primary-color-900 text-white rounded-full text-sm hover:opacity-90"
                    >
                        Go to Dashboard
                    </span>
                </button>
            </div>
        </div>
    );
};

export default ExpiredPopUp;